export enum LicenseNotificationRelativeToType {
  validityEnd = 0,
  renewalStart = 1,
  renewalEnd = 2,
  reinstatementStart = 3,
  reinstatementEnd = 4
}

export enum LicenseNotificationRelativeToLabel {
  'Expiration' = LicenseNotificationRelativeToType.validityEnd,
  'Renewal Start' = LicenseNotificationRelativeToType.renewalStart,
  'Renewal End' = LicenseNotificationRelativeToType.renewalEnd,
  'Reinstatement Start' = LicenseNotificationRelativeToType.reinstatementStart,
  'Reinstatement End' = LicenseNotificationRelativeToType.reinstatementEnd
}
